/*
* Document Manager's Data Source
* Acts as common data store for Document Manager's instances
* Author: @thinkdj
* Date: 20 Aug 2019
*/
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentManagerDataService {

  private dataSource = new BehaviorSubject<any>('');
  private dataChange = new BehaviorSubject<any>('');

  constructor() { }

  /* Propogate data changes */
  fetchDataCanges() : Observable<any> {
    return this.dataChange.asObservable();
  }
  dataHasChanged(message:any) {
    this.dataChange.next(message);
  }

  fetchDocuments() : Observable<any> {
    return this.dataSource.asObservable();
  }

}
